
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   ALL_FINDINGCHARTS,
   ADD_FINDINGCHART,
   FINDINGCHART_ACTION,
   EDIT_FINDINGCHART,
   FETCH_FINDINGCHART,
   DELETE_FINDINGCHART,
   FETCH_STUDENTFINDINGS,
   CHART_FINDINGREPORT,
   ALL_FINDINGREPORTS,
   DELETE_FINDINGREPORTS,
   UPDATE_FINDINGREPORT
} from 'Actions/types';

/**
 * MSK Findings Chart Actions
 */
export const allFindingChart = () =>{
    
    
    return (dispatch) => { 
        dispatch({ type: FINDINGCHART_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getfindingschart', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_FINDINGCHARTS, payload: allroles });
        });
    }
    

}

export const addFindingChart = (teamval) => async (dispatch) => {
    
    var payload={
        "student":teamval.target.student.value,
        "seldate":teamval.target.seldate.value,
        "redflags":teamval.target.redflags.value,
        "previousinjury":teamval.target.previousinjury.value,
        "investigation":teamval.target.investigation.value,
        "coachteam":teamval.target.coachteam.value,
        "scteam":teamval.target.scteam.value,
        "tsgteam":teamval.target.tsgteam.value,
        "submittedby":teamval.target.submittedby.value
     }
     dispatch({ type: FINDINGCHART_ACTION });
    return axios.post(AppConfig.apiurl+'/api/addfindingschart', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allFindingChart()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_FINDINGCHART });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Team not added');
         }            
         return Promise.resolve(resdata);
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const fetchFindingChart = (id) => async (dispatch) => {
	
	var payload={
		"id":id
	}
	
	  dispatch({ type: FINDINGCHART_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/fetchfindingschart', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				var resvalue=resdata.data;			
				dispatch({ type: FETCH_FINDINGCHART, payload:resvalue[0]}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const editFindingChart = (teamval) => async (dispatch) => {
    
      var payload={
            "id":teamval.target.eid.value,
            "redflags":teamval.target.redflags.value,
            "previousinjury":teamval.target.previousinjury.value,
            "investigation":teamval.target.investigation.value,
            "coachteam":teamval.target.coachteam.value,
            "scteam":teamval.target.scteam.value,
            "tsgteam":teamval.target.tsgteam.value,
            "submittedby":teamval.target.submittedby.value
      }
     dispatch({ type: FINDINGCHART_ACTION });
    axios.post(AppConfig.apiurl+'/api/editfindingschart', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allFindingChart()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_FINDINGCHART });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


export const deleteFindingChart = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
    dispatch({ type: FINDINGCHART_ACTION });
    axios.post(AppConfig.apiurl+'/api/deletefindingschart', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allFindingChart()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_FINDINGCHART });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


export const getMskfindscreninglist = (id) => {    
    
   return (dispatch) => { 
       dispatch({ type: FINDINGCHART_ACTION });
       var payload={ "id":id }
       return axios.post(AppConfig.apiurl+'/api/getstudentfindings', payload, { headers: AuthHeader.header })         
       .then(response => {             
           const allroles=response.data.data;
           const resdata=response.data;
           dispatch({ type: FETCH_STUDENTFINDINGS, payload: allroles });
           return Promise.resolve(resdata);
       });
   }   

}

export const uploadFindingReports = (teamval, upfile) => async (dispatch) => {
   let scid=teamval.target.eid.value;
   var payload={
      "id":teamval.target.eid.value, 
      "name":teamval.target.reportname.value, 
      "fileupl":upfile
   }
    dispatch({ type: FINDINGCHART_ACTION });
   axios.post(AppConfig.apiurl+'/api/uploadfindingsreport', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               fetchFindingReports(scid)(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: CHART_FINDINGREPORT });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const fetchFindingReports = (id) => {
    
    console.log(id);
   return (dispatch) => { 
       dispatch({ type: FINDINGCHART_ACTION });
       var payload={ "id":id }
       return axios.post(AppConfig.apiurl+'/api/getuploadedfindingsreport', payload, { headers: AuthHeader.header })         
       .then(response => {             
           const alldata=response.data.data;         
           const resdata=response.data;
           dispatch({ type: ALL_FINDINGREPORTS, payload: alldata });
           return Promise.resolve(resdata);
       });
   }
   

}


export const deleteFindingReports = (id,scid) => async (dispatch) => {
    
   var payload={
       "id":id
    }
    dispatch({ type: FINDINGCHART_ACTION });
   axios.post(AppConfig.apiurl+'/api/deleteuploadedfindingsreport', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               fetchFindingReports(scid)(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: DELETE_FINDINGREPORTS });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const updateFindingReports = (teamval) => async (dispatch) => {
   
   var payload={
      "id":teamval.target.eid.value, 
      "name":teamval.target.updname.value
   }
    dispatch({ type: FINDINGCHART_ACTION });
   axios.post(AppConfig.apiurl+'/api/updatefindingsreport', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              
              NotificationManager.success(resdata.message);               
              dispatch({ type: UPDATE_FINDINGREPORT });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

